const headers = {
  name: "Sales Order",
  navigate: {
    path: [
      {
        name: "Sales Order",
        path: "/app/sales/sales-order",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
